import { render } from "./JuryProfile.vue?vue&type=template&id=3f3dd417&scoped=true"
import script from "./JuryProfile.vue?vue&type=script&lang=js"
export * from "./JuryProfile.vue?vue&type=script&lang=js"

import "./JuryProfile.vue?vue&type=style&index=0&id=3f3dd417&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3dd417"]])

export default __exports__